<template>
  <div class="empty-bookmarks-events">
    <div class="empty-bookmarks-events__content dea-bg-grey-light">
      <h3 class="empty-bookmarks-events__title dea-heading--regular__l">
        Qui troverai tutti gli eventi Deascuola Formazione che aggiungerai ai preferiti.
      </h3>
      <div class="dea-heading--regular__m">
        Non perderti gli eventi di Deascuola Formazione che pensi possano tornarti utili!
      </div>
      <div class="empty-bookmarks-events__instruction">
        <div class="dea-heading--regular__m">
          Clicca (o, se stai usando uno smartphone o un tablet, tocca) l'icona della stella:
        </div>
        <div class="dea-ico-preferiti empty-bookmarks-events__icon"></div>
        <div class="dea-heading--regular__m">
          Diventerà scura
          <div class="dea-ico-preferiti empty-bookmarks-events__icon empty-bookmarks-events__icon--negative"></div>
          e il tuo contenuto sarà disponibile qui.
        </div>
      </div>
      <div class="empty-bookmarks-events__bottom">
        <h4 class=" empty-bookmarks-events__bottom-title dea-heading--medium-xl">
          Cerca un corso di formazione adatto a te!
        </h4>
        <Buttons
          type="a"
          class="dea-button--large dea-button--inline dea-button--iconRight"
          icon="go-to"
          target="_blank"
          href="https://formazione.deascuola.it/offerta-formativa/"
        >
          Vai a Deascuola Formazione
        </Buttons>
      </div>
    </div>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";

export default {
  name: "EmptyEvents",
  components: { Buttons },
  props: {
    linkColor: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_empty-section"; //sass-lint:disable-line clean-import-paths

.empty-bookmarks-events {
  @include empty-section;
  @include empty-section-bookmarks;
}
</style>
